module.exports = __webpack_public_path__ + "static/media/ok.e18fcf76.svg";